/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemExchangeRateRespVo } from './SystemExchangeRateRespVo';
import {
    SystemExchangeRateRespVoFromJSON,
    SystemExchangeRateRespVoFromJSONTyped,
    SystemExchangeRateRespVoToJSON,
    SystemExchangeRateRespVoToJSONTyped,
} from './SystemExchangeRateRespVo';

/**
 * 
 * @export
 * @interface ResponseListSystemExchangeRateRespVo
 */
export interface ResponseListSystemExchangeRateRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListSystemExchangeRateRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListSystemExchangeRateRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<SystemExchangeRateRespVo>}
     * @memberof ResponseListSystemExchangeRateRespVo
     */
    data?: Array<SystemExchangeRateRespVo>;
}

/**
 * Check if a given object implements the ResponseListSystemExchangeRateRespVo interface.
 */
export function instanceOfResponseListSystemExchangeRateRespVo(value: object): value is ResponseListSystemExchangeRateRespVo {
    return true;
}

export function ResponseListSystemExchangeRateRespVoFromJSON(json: any): ResponseListSystemExchangeRateRespVo {
    return ResponseListSystemExchangeRateRespVoFromJSONTyped(json, false);
}

export function ResponseListSystemExchangeRateRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListSystemExchangeRateRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(SystemExchangeRateRespVoFromJSON)),
    };
}

export function ResponseListSystemExchangeRateRespVoToJSON(json: any): ResponseListSystemExchangeRateRespVo {
    return ResponseListSystemExchangeRateRespVoToJSONTyped(json, false);
}

export function ResponseListSystemExchangeRateRespVoToJSONTyped(value?: ResponseListSystemExchangeRateRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(SystemExchangeRateRespVoToJSON)),
    };
}

